<script>
import axios from 'axios';
import { useI18n } from 'vue-i18n';
import AppSelect from '../../shared/AppSelect.vue';

export default {
  components: { AppSelect },
  setup() {
    const i18n = useI18n();
    return {
      t: i18n.t,
    };
  },
  data() {
    return {
      maps: [],
    }
  },
  props: {
    modelValue: {
      type: [String, Number],
      default: ''
    }
  },
  emits: ['update:modelValue'],
  computed: {
    options() {
      return this.maps.map((map) => ({
        value: String(map.id),
        label: map.name,
      }));
    },
  },
  methods: {
    getCurrentLocale() {
      const metaLocale = document
        .querySelector('meta[name="current-locale"]')
        ?.getAttribute('content');
      const htmlLang = document.documentElement.getAttribute('lang');
      const raw = (metaLocale || htmlLang || 'ru').toString();
      const short = raw.split('-')[0];
      return short === 'en' ? 'en' : 'ru';
    },
    getList() {
      const url = "/api/dict/v1/maps";
      axios.get(url, {
        headers: {
          'Accept-Language': this.getCurrentLocale()
        }
      })
            .then(response => {
              this.maps = response.data;
            })
            .catch(error => {
              console.log(error);
            });
    },
    getSelectedMapImage() {
      if (!this.modelValue) return null;
      const selectedMap = this.maps.find(map => map.id.toString() === String(this.modelValue));
      return selectedMap ? selectedMap.image_url : null;
    }
  },
  beforeMount() {
    this.getList();
  }
}
</script>

<template>
  <div class="map-select-wrapper">
    <AppSelect
      variant="events-form"
      class="map-select-app"
      :model-value="modelValue"
      :options="options"
      :placeholder="t('events.form.tournament_rounds.select_map')"
      @update:model-value="$emit('update:modelValue', $event)"
    />
    <div v-if="getSelectedMapImage()" class="map-preview">
      <img :src="getSelectedMapImage()" :alt="'Preview of selected map'" />
    </div>
  </div>
</template>

<style scoped>
.map-select-wrapper {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
}

.map-preview {
  margin-left: 10px;
  flex-shrink: 0;
}

.map-preview img {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #BD9C65;
}
</style>
